import { action, makeAutoObservable, observable } from "mobx"

import type { PagedResultDto } from "@services/dto/pagedResultDto"
import wfCustomFieldService from "@services/workflow/wfCustomFieldService"
import { initMultiLanguageField } from "@lib/helper"

class WfCustomFieldStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any

  constructor() {
    makeAutoObservable(this)
    this.isLoading = false
  }
  @action
  async create(createWfCustomFieldInput) {
    const result = await wfCustomFieldService.create(createWfCustomFieldInput)
    this.tableData.items.push(result)
  }

  @action
  async update(updateWfCustomFieldInput: any) {
    if (
      updateWfCustomFieldInput.possibleValues &&
      updateWfCustomFieldInput.possibleValues.length
    ) {
      updateWfCustomFieldInput.possibleValues =
        updateWfCustomFieldInput.possibleValues.split(";")
    }
    await wfCustomFieldService.update(updateWfCustomFieldInput)
  }

  @action
  async activateOrDeactivate(id: number, isActive) {
    await wfCustomFieldService.activateOrDeactivate(id, isActive)
  }

  @action
  async get(id) {
    this.detailData = await wfCustomFieldService.get({ id })
  }

  @action
  async createWfCustomField() {
    this.detailData = {
      id: 0,
      names: initMultiLanguageField(),
      descriptions: initMultiLanguageField(),
      isActive: true,
    }
  }

  @action
  async getAll(pagedFilterAndSortedRequest: any) {
    this.isLoading = true
    this.tableData = await wfCustomFieldService
      .getAll(pagedFilterAndSortedRequest)
      .finally(() => (this.isLoading = false))
  }
}

export default WfCustomFieldStore
